export const CROUTE_LIMIT = 8;
export const ARTWORK_MAX = 100;

export const IRON_LIMIT = [10, 20];
export const FRONT_LIMIT = [10, 20];
